app
  .controller('ReviewController', ReviewController)
  .controller('ReviewModalController', ReviewModalController)

function ReviewController($scope, $http, $uibModal, $routeParams, $location) {
  'ngInject'

  $scope.inspecoes = []
  $scope.inspecao = {}

  function getInspections() {
    return $http
      .get('/api/v2/inspections-review')
      .then(res => res.data)
      .then(inspecoes => {
        $scope.inspecoes = inspecoes
        if (inspecoes.length === 0) $scope.nothingFound = true
      })
      .catch(errorHandler)
      .then(() => {
        $location.path('/reviews')
      })
  }

  function viewInspection(inspecao) {
    return $http
      .get('/api/v2/inspection/' + inspecao.id)
      .then(res => res.data)
      .then(inspecao => {
        $scope.inspecao = inspecao
      })
      .catch(errorHandler)
  }
  if ($routeParams.id) {
    viewInspection({ id: $routeParams.id })
  }

  function openBundleModal(arquivo) {
    $uibModal.open({
      templateUrl: 'src/review/review-modal.html',
      controller: 'ReviewModalController',
      size: 'lg',
      resolve: {
        data: function() {
          return {
            arquivo: arquivo,
            inspecao: $scope.inspecao,
          }
        },
      },
    })
  }

  $scope.saveReview = () => {
    let { observacao_externa, id } = $scope.inspecao

    if (!observacao_externa) {
      observacao_externa = 'N/a'
    }
    
    $http
      .post('/api/v2/send-review', {
        id,
        observacao_externa
      })
      .then(() => {
        alert.success('Submitted')
        $scope.inspecao = {}
        getInspections()
      })
      .catch(errorHandler)
  }

  getInspections()

  $scope.viewInspection = viewInspection
  $scope.openBundleModal = openBundleModal
}

function ReviewModalController($scope, $uibModalInstance, $http, data) {
  'ngInject'

  $scope.inspecao = data.inspecao
  $scope.arquivo = data.arquivo

  
  $scope.saveReview = () => {
    $http
      .post('/api/v2/review', $scope.arquivo)
      .then(() => {
        alert.success('Comment saved')
      })
      .catch(errorHandler)
  }

  $scope.close = $uibModalInstance.close
}
